export function parseCommaSeparated(value: string | null): string[] {
  if (!value) return [];
  return value.split(",").filter(Boolean);
}

export type BooleanFilterValue = "any" | "yes" | "no";

export function parseBooleanFilter(value: string | null): BooleanFilterValue {
  if (value === "yes" || value === "no") return value;
  return "any";
}

export function booleanFilterToParam(value: BooleanFilterValue): boolean | undefined {
  if (value === "yes") return true;
  if (value === "no") return false;
  return undefined;
}

/** A typed number, or undefined when empty or not a finite number (e.g. a lone "-"). */
export function parseFiniteNumber(value: string): number | undefined {
  if (!value) return undefined;
  const n = Number(value);
  return Number.isFinite(n) ? n : undefined;
}
